import React from "react";
import { NavItem, NavLink } from "reactstrap";
import type { productConfiguratorTabsEnum } from "variables/enums";
import cx from "classnames";
import styles from "./ProductResultTabs.module.scss";

interface TabItemProps {
  tabId: productConfiguratorTabsEnum;
  label: string | React.ReactNode;
  isActive: boolean;
  onClick: (tabId: productConfiguratorTabsEnum) => void;
}

export const TabItem: React.FC<TabItemProps> = ({
  tabId,
  label,
  isActive,
  onClick,
}) => (
  <NavItem className={cx("border-0", styles.tabLink)}>
    <NavLink
      className={cx("py-3 fw-bold fs-7 cursor-pointer text-center", {
        "bg-white text-info": isActive,
        "text-gray-700": !isActive,
        [styles.activeTab]: isActive,
      })}
      onClick={() => onClick(tabId)}
    >
      {label}
    </NavLink>
  </NavItem>
);
